// Shared by the Harpie tabs. Every time here is UTC; epoch values are seconds.

// Clock steps for a time axis, in seconds: the first giving at most TIME_TICKS ticks is used.
const TIME_STEPS = [
  5, 10, 15, 30, 60, 120, 300, 600, 900, 1800, 3600, 7200, 10800, 21600, 43200, 86400,
];
const TIME_TICKS = 7;

function iso(value) {
  const date = value instanceof Date ? value : new Date(typeof value === "number" ? value * 1000 : value);
  return date.toISOString();
}

// "2026-10-21 14:00:05"
export function formatDateTime(value) {
  return iso(value).slice(0, 19).replace("T", " ");
}

// "2026-10-21 14:00"
export function formatMinute(value) {
  return iso(value).slice(0, 16).replace("T", " ");
}

// "10-21 14:00"
export function formatShort(value) {
  return iso(value).slice(5, 16).replace("T", " ");
}

// "14:00:05"
export function formatTime(value) {
  return iso(value).slice(11, 19);
}

// The value of a datetime-local input ("2026-10-21T14:00") for a time, in UTC.
export function toUtcInput(value) {
  return iso(value).slice(0, 16);
}

// A datetime-local input's value read as UTC, or null when blank or not a time.
export function fromUtcInput(text) {
  if (!text) return null;
  const date = new Date(text + "Z");
  return isNaN(date) ? null : date;
}

export function windowLabel(lo, hi) {
  const sameDay = iso(lo).slice(0, 10) === iso(hi).slice(0, 10);
  const fmt = sameDay ? formatTime : (t) => iso(t).slice(5, 19).replace("T", " ");
  const seconds = hi - lo;
  const span =
    seconds < 120
      ? `${seconds.toFixed(0)} s`
      : seconds < 7200
      ? `${(seconds / 60).toFixed(0)} min`
      : `${(seconds / 3600).toFixed(1)} h`;
  return `${fmt(lo)} – ${fmt(hi)} UTC (${span})`;
}

// Ticks on whole clock steps for an axis from t0 to t0 + span, and their format.
export function timeTicks(t0, span) {
  span = Math.max(span, 1);
  const step = TIME_STEPS.find((s) => span / s <= TIME_TICKS) || TIME_STEPS[TIME_STEPS.length - 1];
  const format = span > 86400 ? formatShort : step < 60 ? formatTime : (t) => formatTime(t).slice(0, 5);
  const ticks = [];
  for (let tick = Math.ceil(t0 / step) * step; tick <= t0 + span; tick += step) {
    ticks.push(tick);
  }
  return { ticks, format };
}

// The first index whose value is >= x (bisect_left) or > x (bisect_right).
export function bisectLeft(values, x) {
  let lo = 0;
  let hi = values.length;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (values[mid] < x) lo = mid + 1;
    else hi = mid;
  }
  return lo;
}

export function bisectRight(values, x) {
  let lo = 0;
  let hi = values.length;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (values[mid] <= x) lo = mid + 1;
    else hi = mid;
  }
  return lo;
}

// At most 2 * buckets points: each bucket's lowest and highest, in x order, so spikes survive.
export function minMaxDownsample(xs, ys, buckets) {
  const n = xs.length;
  if (buckets < 1 || n <= 2 * buckets) return [xs, ys];
  const outX = [];
  const outY = [];
  for (let b = 0; b < buckets; b++) {
    const lo = Math.floor((b * n) / buckets);
    const hi = Math.floor(((b + 1) * n) / buckets);
    if (lo === hi) continue;
    let iMin = lo;
    let iMax = lo;
    for (let i = lo + 1; i < hi; i++) {
      if (ys[i] < ys[iMin]) iMin = i;
      if (ys[i] > ys[iMax]) iMax = i;
    }
    for (const i of iMin === iMax ? [iMin] : [Math.min(iMin, iMax), Math.max(iMin, iMax)]) {
      outX.push(xs[i]);
      outY.push(ys[i]);
    }
  }
  return [outX, outY];
}
